import monitor from '../monitor';

enum MSDKVersion {
  V3 = 'V3',
  V5 = 'V5',
}

// 事件名称常量
const EVENTS = {
  MSDK_PARAM_INCOMPLETE: 'msdk_param_incomplete',
  PARAM_REPEAT: 'param_repeat',
  VALIDATION_ERROR: 'url_validation_error',
} as const;

const MSDK_CONFIG = {
  [MSDKVersion.V3]: {
    identifier: 'msdkEncodeParam',
    requiredParams: ['msdkEncodeParam', 'timestamp', 'appid', 'openid', 'algorithm', 'encode', 'sig', 'version'],
  },
  [MSDKVersion.V5]: {
    identifier: 'itopencodeparam',
    requiredParams: ['sig', 'version', 'os', 'gameid', 'ts', 'itopencodeparam'], // channelid 有些游戏没有，暂时不列为必填
  },
} as const;

const hasRepeatedParams = (url: string): boolean => {
  try {
    const urlObj = new URL(url);
    const queryString = urlObj.search.substring(1);
    if (!queryString) return false;

    // 手动解析原始查询字符串来检测重复参数
    const paramNames = queryString.split('&').map((param) => param.split('=')[0]);
    const uniqueParamNames = new Set(paramNames);

    return paramNames.length !== uniqueParamNames.size;
  } catch {
    return false;
  }
};

const hasAllRequiredParams = (url: string, requiredParams: readonly string[]): boolean => {
  try {
    const urlObj = new URL(url);
    return requiredParams.every((param) => urlObj.searchParams.has(param));
  } catch {
    return false;
  }
};

const detectAndValidateMSDKVersion = (url: string): void => {
  try {
    for (const config of Object.values(MSDK_CONFIG)) {
      // 非当前版本直接跳过
      if (!url.includes(config.identifier)) continue;
      const hasAllParams = hasAllRequiredParams(url, config.requiredParams);
      if (!hasAllParams) {
        monitor.reportEvent(EVENTS.MSDK_PARAM_INCOMPLETE);
      }
      return;
    }
  } catch (error) {
    monitor.reportEvent(EVENTS.VALIDATION_ERROR);
  }
};

const validateUrlQueryParams = async (): Promise<void> => {
  try {
    const url = window.location.href;
    // 检查参数重复
    if (hasRepeatedParams(url)) {
      monitor.reportEvent(EVENTS.PARAM_REPEAT);
    }
    // 检测MSDK版本并验证参数
    detectAndValidateMSDKVersion(url);
  } catch (error) {
    monitor.reportEvent(EVENTS.VALIDATION_ERROR);
  }
};

export { validateUrlQueryParams };
